<!-- src/components/LogViewer.vue -->
<template>
    <div>
        <h1>日志查看器</h1>
        <ul>
            <li v-for="log in logs" :key="log">{{ log }}</li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters(['logs'])
    }
};
</script>

<style scoped>
/* 添加一些样式 */
</style>